import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  refcode: '',
  reflink: '',
  balance: '',

  activeReferrals: {
    level1: null,
    level2: null,
    level3: null,
  },

  withdrawMin: null,
  withdrawFee: null,
  withdrawMethods: null,
  withdrawStatus: null,

  servers: {
    stats: null,
    rewards: null,
    conversion: null,
  },

  clients: null,

  network: null,

  promocodes: {
    list: null,
    discounts: null,
    createStatus: null,
    deleteStatus: null,
  }
}

export const partnersSlice = createSlice({
  name: 'partners',
  initialState,
  reducers: {
    setRefcode: (state, action) => { state.refcode = action.payload },
    setReflink: (state, action) => { state.reflink = action.payload },
    setPartnerBalance: (state, action) => { state.balance = action.payload },

    setActiveReferralsLevel1: (state, action) => { state.activeReferrals.level1 = action.payload },
    setActiveReferralsLevel2: (state, action) => { state.activeReferrals.level2 = action.payload },
    setActiveReferralsLevel3: (state, action) => { state.activeReferrals.level3 = action.payload },

    setWithdrawMin: (state, action) => { state.withdrawMin = action.payload },
    setWithdrawFee: (state, action) => { state.withdrawFee = action.payload },
    setWithdrawMethods: (state, action) => { state.withdrawMethods = action.payload },
    setWithdrawStatus: (state, action) => { state.withdrawStatus = action.payload },

    setServersStats: (state, action) => { state.servers.stats = action.payload },
    setServersRewards: (state, action) => { state.servers.rewards = action.payload },
    setServersConversion: (state, action) => { state.servers.conversion = action.payload },

    setClients: (state, action) => { state.clients = action.payload },

    setNetwork: (state, action) => { state.network = action.payload },

    setPromocodes: (state, action) => { state.promocodes.list = action.payload },
    setPromocodeDiscounts: (state, action) => { state.promocodes.discounts = action.payload },
    setCreatePromocodeStatus: (state, action) => { state.promocodes.createStatus = action.payload },
    setDeletePromocodeStatus: (state, action) => { state.promocodes.deleteStatus = action.payload },

    resetPartners: () => initialState,
  },
})

export const {
  setRefcode,
  setReflink,
  setPartnerBalance,

  setActiveReferralsLevel1,
  setActiveReferralsLevel2,
  setActiveReferralsLevel3,

  setWithdrawMin,
  setWithdrawFee,
  setWithdrawMethods,
  setWithdrawStatus,

  setServersStats,
  setServersRewards,
  setServersConversion,

  setClients,

  setNetwork,

  setPromocodes,
  setPromocodeDiscounts,
  setCreatePromocodeStatus,
  setDeletePromocodeStatus,

  resetPartners,
} = partnersSlice.actions

export default partnersSlice.reducer
